import * as colors from "@faire/design-tokens/index";

// eslint-disable-next-line import/no-unassigned-import
import "../../__generated__/variables.scss";

export const buildColorDesignTokens = () => {
  return Object.entries(colors).flatMap(([paletteKey, paletteValue]) => {
    return Object.entries(paletteValue).flatMap(([styleKey, styleValue]) => {
      return Object.entries(styleValue).map(([colorKey, colorValue]) => {
        return {
          name: `${paletteKey}.${styleKey}.${colorKey}`,
          value: `var(--color-${paletteKey}-${styleKey}-${colorKey}, ${colorValue})`,
        };
      });
    });
  });
};
